import React from 'react';
import { RoundedButtonWithText } from '../RoundedButtonWithText';

export const WithdrawConsentButton = ({ onClick, disabled }) => (
  <RoundedButtonWithText
    variant="outlined" 
    onClick={onClick}
    disabled={disabled}
  >I Withdraw Consent*</RoundedButtonWithText>
);